import { render, staticRenderFns } from "./jazzCash.vue?vue&type=template&id=53ff95df&scoped=true&"
import script from "./jazzCash.vue?vue&type=script&lang=js&"
export * from "./jazzCash.vue?vue&type=script&lang=js&"
import style0 from "./jazzCash.vue?vue&type=style&index=0&id=53ff95df&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53ff95df",
  null
  
)

export default component.exports